import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

export const analysisFortuneInfo = createAsyncThunk<any, any>(
  'analysisFortuneInfo',
  async (arg, store) => {
    return req(
      '/activity/get_banner_info',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const reportSlice = createSlice({
  name: 'activity',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(analysisFortuneInfo.fulfilled, (state, action) => {
      return action.payload
    })
  },
})

export default reportSlice.reducer
